import { computed, makeObservable } from 'mobx';
import { SEPARADOR_CLASSE_NUMERO_PADRAO } from '../../util/NumeroProcessoUtil';
import { Filtro } from './Filtro';

export default class FiltroMesmaFaseSessaoAnterior extends Filtro {
    tipo = 'booleano';

    get label() {
        return 'Mesma fase em sessão anterior';
    }

    constructor(props) {
        super(props);

        makeObservable(this, {
            carregandoDadosComplementares: computed
        });
    }

    getValorOpcao(registro) {
        const julgamentoAnterior = registro?.detalhes?.julgamentoAnterior;

        if (!julgamentoAnterior) {
            return false;
        }

        const faseAtual = registro.classeProcesso;

        if (!faseAtual) {
            return false;
        }

        const faseAnterior = julgamentoAnterior.numeroProcesso?.split(SEPARADOR_CLASSE_NUMERO_PADRAO)[0];

        return faseAnterior === faseAtual;
    }

    getDescricao(valor) {
        return this.labelBooleanoSimNao(valor);
    }

    get carregandoDadosComplementares() {
        return this.store.carregandoJulgamentosAnteriores;
    }

    renderCarregando() {
        return this.renderCircularProgress('julgamentos anteriores...');
    }
}
